import { call, put, takeLatest } from 'redux-saga/effects';
import { get } from 'lodash';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { CHANGE_DESIGN, CHANGE_DESIGN_SUCCESS, CHANGE_DESIGN_FAIL } from '../redux/Design';
import { PUT } from '../consts/Methods';

function* changeDesignFlow({ payload: { design, promise: { resolve, reject, }, }, }) {
  try {
    const endpoint = `${apiRoot}/designs/${get(design, 'id')}`;
    let params = design;
    const logo = get(params, 'logo');
    if (logo && !logo.startsWith('data:image')) {
      params = params.sliece('logo');
    }
    const response = yield call(apiCall, { method: PUT, endpoint, params: { design: params, }, });
    yield put(CHANGE_DESIGN_SUCCESS({ data: response, }));
    resolve();
  } catch (error) {
    yield put(CHANGE_DESIGN_FAIL(error));
    reject();
  }
}

export default function* ChangeDesign() {
  yield takeLatest(CHANGE_DESIGN, changeDesignFlow);
}
